/**
 * Model for admin service module.
 *
 * @author mohit.khurana@vernuso.com (Mohit Khurana)
 */
export class Service {
    // Model properties have been kept in lowercase as per the FormParams
    // accepted by rest server.
    serviceType: string;
    serviceName: string
}


// WEBPACK FOOTER //
// ./src/app/admin/services/service.model.ts